import React from 'react'
import {Hidden, Typography, Button, Paper } from '@material-ui/core';


export default class Commons{

   



    generateAppBarButtons = (buttonsArray)=>{
        //  buttonsArray = [
        //      {
        //          onClick: null,
        //          text:'',
        //          icon:''
        //      },
        //  ]

        let rez = []
        for(let i = 0 ; i<buttonsArray.length; i++){
            rez.push(
                <Button className='pm-appbar-buttons' onClick={buttonsArray[i].onClick}>
                    <i className="material-icons">{buttonsArray[i].icon}</i> 
                    <Hidden smDown>
                    <span className='pm-appbar-button-text'>
                            {buttonsArray[i].text}    
                        </span> 
                    </Hidden> 
                
                    
                </Button >
            )
        }
        
        return rez
    }

    generateAccesDeniedPaper = (title, text, theme)=>{
        return <Paper style={{
            backgroundColor:theme.paperCard.backgroundColor,
            color:theme.paperCard.color,
            textAlign:'center'
        }}> 
            <h3>{title}</h3>
            <p>{text}</p> 
        </Paper>
    }
}